import types from './types';
export default {
  [types.SET_LOADING](state, isLoading) {
    state.loading = isLoading;
  },
  setIsNavOpen(state, value) {
    state.isNavOpen = value;
  },
  toggleNav(state) {
    state.isNavOpen = !state.isNavOpen;
  },
  hideNav(state) {
    state.isNavOpen = false;
  },
  setIsMobileDensity(state, value) {
    state.isMobileDensity = value;
  },
  setShowStudentInfo(state, value) {
    state.showStudentInfo = value;
  },
  setSelectedStudentId(state, value) {
    state.selectedStudentId = value;
  },
  setIsOpenSearchStudent(state, value) {
    state.isOpenSearchStudent = value;
  },
};
